import { DbName, DbVersion, StoreName } from "../@core/constants/db_name";
import {
  dbDeleteData,
  dbGetAllData,
  dbInsert,
  dbInsertAllData,
  dbUpdateData,
} from "./crudDB";

export async function dbCategoryListAllData(data) {
  await dbInsertAllData(
    DbName.CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.CATEGORY_LIST,
    data
  );
}

export async function dbGetAllCategoryData() {
  return await dbGetAllData(
    DbName.CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.CATEGORY_LIST,
    "id"
  );
}

export async function dbUpdateCategoryListData(data) {
  await dbUpdateData(
    DbName.CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.CATEGORY_LIST,
    "id",
    "waba_tc_id",
    data
  );
}

export async function dbDeleteCategoryListData(id) {
  await dbDeleteData(
    DbName.CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.CATEGORY_LIST,
    "id",
    "waba_tc_id",
    id
  );
}

export async function dbCategoryListDataInsert(data) {
  await dbInsert(
    DbName.CATEGORY_LIST_DB,
    DbVersion.FIRST,
    StoreName.CATEGORY_LIST,
    "id",
    data,
    "asc"
  );
}
